import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { useEffectRef } from "@js/hooks/use-effect-ref";

import { openIdentityVerificationModal } from "./identity-verification-modal";

const VERIFY_IDENTITY_QUERY_PARAM = "verify_identity";

export const OpenIdentityVerificationModalProvider = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const verifyIdentityParamValue = searchParams.get(
    VERIFY_IDENTITY_QUERY_PARAM,
  );
  const verifyIdentityParamIsSet = verifyIdentityParamValue !== null;

  const setSearchParamsRef = useEffectRef(setSearchParams);
  useEffect(() => {
    if (!verifyIdentityParamIsSet) {
      return;
    }

    setSearchParamsRef.current((previousParams) => {
      const searchParamsCopy = new URLSearchParams(previousParams);
      searchParamsCopy.delete(VERIFY_IDENTITY_QUERY_PARAM);

      return searchParamsCopy;
    });

    openIdentityVerificationModal();
  }, [verifyIdentityParamIsSet, setSearchParamsRef]);

  return <></>;
};
